import React, { useState } from 'react';
import { Button, Form, FormGroup, Label, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';

const NewServicePricingModal = ({ isOpen, toggle, onAdd, timeframes, pricingTiers = [], services = [] }) => {
    const [basePrice, setBasePrice] = useState('');
    const [selectedTimeframe, setSelectedTimeframe] = useState('');
    const [selectedPricingTier, setSelectedPricingTier] = useState('');
    const [selectedService, setSelectedService] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onAdd({
            base_price: parseFloat(basePrice),
            timeframe: selectedTimeframe,
            pricing_tier: selectedPricingTier,
            service: selectedService
        });
    };

    const handleModalClosed = () => {
        setBasePrice('');
        setSelectedTimeframe('');
        setSelectedPricingTier('');
        setSelectedService('');
        toggle();
    }

    return (
        <Modal isOpen={isOpen} toggle={handleModalClosed} autoFocus={false}>
            <ModalHeader toggle={handleModalClosed}>New Service Pricing</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <FormGroup>
                        <Label for="timeframe">Organization Timeframe</Label>
                        <Input type="select" name="timeframe" id="timeframe" value={selectedTimeframe} onChange={(e) => setSelectedTimeframe(e.target.value)} required>
                            <option value="">-- Select a timeframe --</option>
                            {timeframes.map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="pricingTier">Pricing Tier</Label>
                        <Input type="select" name="pricingTier" id="pricingTier" value={selectedPricingTier} onChange={(e) => setSelectedPricingTier(e.target.value)} required>
                            <option value="">-- Select a pricing tier --</option>
                            {pricingTiers.map(t => (
                                <option key={t.id} value={t.id}>{t.name}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="service">Service</Label>
                        <Input type="select" name="service" id="service" value={selectedService} onChange={(e) => setSelectedService(e.target.value)} required>
                            <option value="">-- Select a service --</option>
                            {services.map(s => (
                                <option key={s.id} value={s.id}>{s.title}</option>
                            ))}
                        </Input>
                    </FormGroup>
                    <FormGroup>
                        <Label for="basePrice">Base Price</Label>
                        <Input type="number" name="basePrice" id="basePrice" value={basePrice} onChange={(e) => setBasePrice(e.target.value)} step="0.01" required />
                    </FormGroup>
                    <Button color="primary" type="submit">Save</Button>{' '}
                    <Button color="secondary" onClick={handleModalClosed}>Cancel</Button>
                </Form>
            </ModalBody>
        </Modal>
    );
};

export default NewServicePricingModal;
